import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'widget-guest-rate-info',
    templateUrl: './guest-rate-info.component.html',
    styleUrls: ['./guest-rate-info.component.scss'],
    standalone: false
})
export class GuestRateInfoComponent implements OnInit {

  @Input() survey

  @Input()
  layoutView: 'list-view' | 'card-view'

  @Input()
  value: any

  @Input()
  text: string

  @Input()
  icon: string

  constructor() { }

  ngOnInit() {
  }

  get isCardView() { return this.layoutView === 'card-view'}
  get classStay() {
    if(this.layoutView === 'list-view'){
      return 'text-center'
    }
    if(this.layoutView === 'card-view'){
      return 'adjust-card-view'
    }
  }
  get classText() {
    if(this.layoutView === 'list-view'){
      return 'legend'
    }
    if(this.layoutView === 'card-view'){
      return 'col-5 adjust-text'
    }
  }

}
